module.exports = __webpack_public_path__ + "img/upload-file-feature-contact-form.gif";